import { quoteObj } from '../fmt';
import { TRAY_MAX, getTray, toggleTray, useInTray, type TrayItem } from '../tray';
import { Icon } from './Icon';
import { toast } from './Toast';

/**
 * 「담기」 (계획서 U1 · 루브릭 R2-1) — 로그인 없이 이 브라우저의 트레이에 담는다.
 * 담기 전: bookmark · 「담기」, 담은 뒤: bookmark-check(--accent) · 「담음」 — 색만이 아니라 아이콘 · 글자도 바뀐다.
 * overlay — 격자 카드 썸네일 위 아이콘 버튼(이름은 aria-label), text — 목록 행 · 상세 · 비교 표의 아이콘 + 글자.
 * 누르면 토스트로 결과와 담은 개수를 알린다(루브릭 F4 의 토스트를 안전하게 볼 수 있는 경로).
 */
export default function SaveToggle({ item, variant = 'text', className }: {
  item: Omit<TrayItem, 'at'>;
  variant?: 'overlay' | 'text';
  className?: string;
}) {
  const saved = useInTray(item.fabric_id);
  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const r = toggleTray(item);
    const n = getTray().length;
    if (r === 'full') toast(`트레이에는 ${TRAY_MAX}개까지 담을 수 있습니다 — 컬렉션으로 저장하고 비워 주세요`, 'error');
    else if (r === 'removed') toast(`${quoteObj(item.fabric_name)} 뺐습니다 · 담은 원단 ${n}`, 'info');
    else toast(`${quoteObj(item.fabric_name)} 담았습니다 · 담은 원단 ${n}`);
  };
  // 이름이 같은 원단이 많아(같은 도안 · 다른 품번) 품번을 함께 읽힌다
  const who = item.part_number ? `${item.fabric_name} (${item.part_number})` : item.fabric_name;
  const label = saved ? `${who} 담음 — 누르면 뺍니다` : `${who} 담기`;

  if (variant === 'overlay') {
    return (
      <button type="button" className={`save-ov${saved ? ' on' : ''}${className ? ` ${className}` : ''}`}
              aria-pressed={saved} aria-label={label} title={saved ? '담음 — 누르면 뺍니다' : '담기'} onClick={onClick}>
        <Icon name={saved ? 'bookmark-check' : 'bookmark'} size={18} />
      </button>
    );
  }
  return (
    <button type="button" className={`btn sm save-btn${saved ? ' on' : ''}${className ? ` ${className}` : ''}`}
            aria-pressed={saved} aria-label={label} onClick={onClick}>
      <Icon name={saved ? 'bookmark-check' : 'bookmark'} size={16} />
      <span>{saved ? '담음' : '담기'}</span>
    </button>
  );
}
